import './App.css';
import Frame from './Components/Frame/Frame';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Video from './Components/Video/Video';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path='/' element={<Frame />} />
          <Route path='/watch?/:videoId' element={<Video />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
